/** 接口调用工具*/

import axios from 'axios' // 引用axios
// 配置API接口地址
let root = '/api/exam_online_interface'
axios.defaults.headers.post['content-Type'] = 'application/json;charset=UTF-8';

function apiAxios (method, url,params) {

  return new Promise((resolve, reject) => {
    axios({
      method: method,
      url: root+url,
      data: method === 'POST' ? params : null,
      params: method === 'GET' ? params : null,
      withCredentials: false
    })
      // 此处的.then属于axios
      .then(
        //成功时调用
        function (response) {
          console.log("do ajax " + url + "  success");
          let data = response.data;
          if (data) {
            let messageString = "";
            if (!data.meta.success) {
              if (data.meta.message) {
                messageString = data.meta.message + "<br />";
              }
              if (data.validateErrorList && data.validateErrorList.length > 0) {
                for ( var i in data.validateErrorList) {
                  messageString += data.validateErrorList[i].validateMessage
                    + "<br />";
                }
              }
              if (data.meta.message == "用户不存在或者超时无效"){
                console.log("用户不存在或者超时无效")
              } else {
                console.log("错误")
              }
              reject(response.data);
            } else {
              resolve(response.data);
            }
          }
        },
        //失败时调用
        function(res){
          console.log("do ajax " + url + "  error");
          console.log(res);
          reject(res);
        })
  })
}

// 返回在vue模板中的调用接口
export default {
  get: function (url,params) {
    return apiAxios('GET', url, params)
  },
  post: function (url, params) {
    return apiAxios('POST', url, params)
  }
}



// WEBPACK FOOTER //
// ./src/util/axios.js